// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"15eba381","273":"4906cfb1","436":"89dd8e81","583":"0fcabc36","858":"b497378b","881":"1ff0c0ea","970":"e883a2d7"}[chunkId] + ".chunk.js";
};